import { render, staticRenderFns } from "./ImageObject.vue?vue&type=template&id=cc6961a8&scoped=true&"
import script from "./ImageObject.vue?vue&type=script&lang=ts&"
export * from "./ImageObject.vue?vue&type=script&lang=ts&"
import style0 from "./ImageObject.vue?vue&type=style&index=0&id=cc6961a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6961a8",
  null
  
)

export default component.exports